import { ModuleItemSubType } from './module-item-sub-type';

export interface ModuleItemType {
  type?: string;
  label?: string;
  subTypes?: ModuleItemSubType[];
}

export enum ModuleItemAvailableType {
  INFO = 'info',
  NUMBER = 'number',
  TEXT = 'text',
  SPECIAL = 'special',
  INDEX = 'index',
}
